"use client";

import { ConvexReactClient } from "convex/react";
import { ConvexProviderWithClerk } from "convex/react-clerk";
import { useAuth } from "@clerk/nextjs";
import { ReactNode, useEffect } from "react";
import { initSubscriptionClientAuth } from "@/lib/participantPropertyAtomCreatorConvex";

const convexUrl = process.env.NEXT_PUBLIC_CONVEX_URL;

if (!convexUrl) {
  console.warn(
    "NEXT_PUBLIC_CONVEX_URL is not set. Convex hooks will fail until the environment variable is configured.",
  );
}

// Exported singleton - once ConvexProviderWithClerk mounts, auth is set on this client
export const convexClient = convexUrl ? new ConvexReactClient(convexUrl) : null;

// Inner component to set up subscription client auth
function SubscriptionAuthSetup() {
  const { getToken } = useAuth();

  useEffect(() => {
    // Set auth on the subscription client using Clerk's token fetcher
    initSubscriptionClientAuth(async () => {
      const token = await getToken({ template: "convex" });
      return token;
    });
  }, [getToken]);

  return null;
}

export function ConvexClientProvider({ children }: { children: ReactNode }) {
  if (!convexClient) {
    return <>{children}</>;
  }

  return (
    <ConvexProviderWithClerk client={convexClient} useAuth={useAuth}>
      <SubscriptionAuthSetup />
      {children}
    </ConvexProviderWithClerk>
  );
}
